import GraphicRuleEditForm from "./graphic-rule-edit-form";

export default GraphicRuleEditForm;
